define((require) => {
    "use strict";

    const Action       = require("shared/ui/experience/action/Action");
    const Window       = require("shared/services/Window");
    const ViewerEvents = require("shared/services/ViewerEvents");

    /**
     * Action that executes javascript on the top most reachable (client) page.
     *
     * @class JsAction
     * @constructor
     */
    return Action.extend("JsAction", {
        // Note: "clientSpace" is not set to true to allow users to enter stuff like "alert('foo')" as well.

        defaults: {
            code: ""
        },

        _event: ViewerEvents.JAVASCRIPT_EXECUTE,

        _activateable() {
            return this.get("code") ? null : "Missing code";
        },

        /**
         * @protected
         * Activates this JS action. <p>
         *
         * A JS action can ever only run when the owning Experience is embedded via channels or we will get
         * cross domain issues.
         *
         * @return {*} The result of executing the code; can be falsey.
         */
        _activate() {
            Window.run(this.get("code"));
            return {actionId: this.id, widgetId: this.attributes.widgetId};
        }

    }, {
        TYPE: "js"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/js/JsAction.js